// extracted by mini-css-extract-plugin
module.exports = {"transactions-page-content":"Transaction_transactions-page-content__07e8c"};